import React, { useEffect, useState } from "react";
import { Auth } from "aws-amplify";
import { Modal } from "./Modal";
import { useHistory } from "react-router-dom";
import { Button } from "@material-ui/core";

export const AccessTokenRefresh = () => {
  const [warningModalOpen, setWarningModalOpen] = useState(false);

  const history = useHistory();

  const warningModalClose = () => setWarningModalOpen(false);
  const handleWarningModalOpen = () => setWarningModalOpen(true);

  const handleRelogin = () => {
    localStorage.setItem("sessionExpired", true);
    history.push("/logout");
  };

  useEffect(() => {
    Auth.currentSession()
      .then((data) => {
        if (!data) return;
        // Date when refresh token will expire
        const authTime =
          data.accessToken.payload.auth_time * 1000 + 10 * 60 * 60 * 1000;
        const currentDate = Date.parse(new Date(Date.now()));
        const twentyMinutesLeft = authTime - 1200 * 1000;
        // Amount of milliseconds left before the warning
        const timer = twentyMinutesLeft - currentDate;
        if (timer > 0) {
          //Open warning message with request to reauthenticate
          setTimeout(handleWarningModalOpen, timer);
        }
        //Kick user out when refresh token is expired
        setTimeout(handleRelogin, authTime - currentDate);
      })
      .catch((err) => {
        //Kick user out if session error occures
        console.log(err);
        handleRelogin();
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {warningModalOpen && (
        <Modal
          isOpen={warningModalOpen}
          submitable
          onClose={handleWarningModalOpen}
          maxWidth="md"
          modalContent={
            <>
              <div className="text-center py-5">
                <h3 className="my-3">
                  Your session will expire in 20 minutes. Please, save your
                  progress and reauthenticate.
                </h3>
                <div className="d-flex mt-10 mb-5 align-items-center justify-content-center">
                  <Button
                    onClick={handleRelogin}
                    variant="outlined"
                    color="secondary"
                    size="large"
                    className="mr-3"
                    data-testid="cancel"
                  >
                    Logout
                  </Button>
                  <Button
                    onClick={warningModalClose}
                    variant="contained"
                    color="secondary"
                    size="large"
                    data-testid="submit"
                  >
                    Close
                  </Button>
                </div>
              </div>
            </>
          }
        />
      )}
    </>
  );
};
